type MessageData = any;

type Validator = (data: MessageData) => boolean;

const expectedKeys = ['rentalAgreementNumber', 'policyNumber', 'vin', 'channelID', 'type', 'uuid', 'phoneNumber'];

const partnerValidators: Record<string, Validator> = {
  CRA: (data) => !!data.rentalAgreementNumber,
  ENC: (data) => !!data.policyNumber,
  V15: (data) => !!data.vin && !!data.channelID,
  JJ: (data) => data.type === 'MEMBER_DATA' && !!data.uuid,
  L28: (data) => !!data.phoneNumber
};

export const checkEnhancedAuthMessageData = (messageData: MessageData, partnerCode : string): boolean => {
  const code = partnerCode?.toUpperCase();

  const validator = partnerValidators[code];

  return validator ? validator(messageData) : false;
};


export const isValidPartnerCodeForEnhancedAuth = (partnerCode: string): boolean => {
  const code = partnerCode?.toUpperCase();
  return Object.prototype.hasOwnProperty.call(partnerValidators, code);
};

export const normalizeMessageData = (data: Record<string, any>): Record<string, any> => {
  const normalizedData: Record<string, any> = {};
  const inputKeys = Object.keys(data);

  inputKeys.forEach(inputKey => {
    const matchingKey = expectedKeys.find(expectedKey =>
      expectedKey.toLowerCase() === inputKey.toLowerCase()
    );

    if (matchingKey) {
      normalizedData[matchingKey] = data[inputKey];
    } else {
      normalizedData[inputKey] = data[inputKey];
    }
  });

  return normalizedData;
};
